module.exports = __webpack_public_path__ + "static/media/Residential_11.20a938a0.jpg";